export enum LINK_BUTTON_VARIANTS {
  PRIMARY = 'primary',
  NEUTRAL = 'neutral',
}
